import React, {useState} from "react";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

export default function SelectBox({
                                      field,
                                      form: { touched, errors, setFieldValue },
                                      ...props
                                  }) {
    const [expanded, setExpanded] = useState([0]);
    return (
        <div className={"form-group col-md-" + (props.colNumber || 4)}>
            <label className="text-black font-w600">
                {props.required ? "*" : ""}
                {props.label}
            </label>
            <CheckboxTree
                name={field.name}
                nodes={props.nodes}
                checked={field.value}
                expanded={expanded}
                onCheck={checked => setFieldValue(field.name, checked)}
                onExpand={e => setExpanded( e )}
                {...field}
                {...props}
            />
            {errors[field.name] && (
                <span className="text-danger">
          <small>*{errors[field.name]}</small>
        </span>
            )}
        </div>
    );
}
